import React from 'react';
import { Box, Flex, VStack, Text, RadioGroup, Radio, useDisclosure, HStack, Button } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { noop } from "../../utils";
import { AddAddressModal } from "./AddAddressModal";
export var SelectAddress = function SelectAddress(props) {
  var _a = props.onChangeType,
      onChangeType = _a === void 0 ? noop : _a,
      children = props.children,
      renderAddressForm = props.renderAddressForm,
      _b = props.addressType,
      addressType = _b === void 0 ? 'company' : _b;
  var addAddressModalDisclosure = useDisclosure();
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      border: '1px solid',
      borderColor: 'gray.200',
      borderRadius: '8px',
      p: '6',
      pb: 0
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    mb: "3"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      fontWeight: 'bold',
      fontSize: '20px'
    }
  }, "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35"), /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    textDecoration: "underline",
    cursor: "pointer",
    userSelect: "none",
    fontWeight: "bold",
    color: "brand.400",
    onClick: addAddressModalDisclosure.onOpen,
    layerStyle: "actionable",
    "data-testid": "add-address-button"
  }, "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48")), /*#__PURE__*/React.createElement(VStack, {
    spacing: "3",
    sx: {
      alignItems: 'flex-start',
      mb: 4
    }
  }, /*#__PURE__*/React.createElement(Box, {
    mr: "4"
  }, "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35\u0E43\u0E19\u0E19\u0E32\u0E21"), /*#__PURE__*/React.createElement(RadioGroup, {
    value: addressType,
    onChange: onChangeType
  }, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Radio, {
    colorScheme: "brand",
    value: "individual",
    layerStyle: "actionable",
    id: "address-individual"
  }, /*#__PURE__*/React.createElement(Text, {
    layerStyle: "actionable",
    sx: {
      fontWeight: addressType === 'individual' ? 'medium' : 'normal'
    }
  }, "\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E18\u0E23\u0E23\u0E21\u0E14\u0E32")), /*#__PURE__*/React.createElement(Radio, {
    colorScheme: "brand",
    value: "company",
    layerStyle: "actionable",
    id: "address-company"
  }, /*#__PURE__*/React.createElement(Text, {
    layerStyle: "actionable",
    sx: {
      fontWeight: addressType === 'company' ? 'medium' : 'normal'
    }
  }, "\u0E19\u0E34\u0E15\u0E34\u0E1A\u0E38\u0E04\u0E04\u0E25"))))), /*#__PURE__*/React.createElement(Box, null, !isEmpty(children) ? children : /*#__PURE__*/React.createElement(Text, {
    sx: {
      p: 4,
      my: 6,
      color: 'gray.400',
      textAlign: 'center'
    }
  }, "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48")), /*#__PURE__*/React.createElement(AddAddressModal, {
    renderAddressForm: renderAddressForm,
    addressType: addressType,
    disclosure: addAddressModalDisclosure
  }));
};